import { useContext } from "react";
import { useApi } from "../../../contexts/app/provider";
import { SysMessagesContext } from "../../../contexts/sys_messages/context";
import { SysMessageLevel } from "../../../contexts/sys_messages/type";
import {
  useGetMyRunScheduleQuery,
  useUpdateMyRunScheduleMutation,
} from "../../../services/api/__generated__/backend_gateway-types";
import { RunScheduleComponent } from "./component";

export const RunScheduleContainer = () => {
  const { apiService } = useApi();
  const { addSystemMessage } = useContext(SysMessagesContext);

  const { data, loading, refetch } = useGetMyRunScheduleQuery({
    client: apiService.getClient(),
  });

  const [updateMyRunSchedule, { loading: saving }] =
    useUpdateMyRunScheduleMutation({
      client: apiService.getClient(),
    });

  const schedule = data?.getMyRunSchedule || null;
  // No runtrigger rule for this org (or still loading) — nothing to show.
  if (loading || !schedule) {
    return null;
  }

  const handleSave = async (hourEastern: number, minuteEastern: number) => {
    const result = await updateMyRunSchedule({
      variables: { hourEastern, minuteEastern },
    });
    const newExpression = result.data?.updateMyRunSchedule;
    if (newExpression) {
      addSystemMessage({
        level: SysMessageLevel.SUCCESS,
        message: "Daily run time updated.",
      });
      refetch();
      return true;
    }
    addSystemMessage({
      level: SysMessageLevel.DANGER,
      message:
        "Could not update the run time. Please try again or contact Atomic.",
    });
    return false;
  };

  return (
    <RunScheduleComponent
      scheduleExpression={schedule.scheduleExpression}
      isEnabled={schedule.isEnabled}
      saving={saving}
      onSave={handleSave}
    />
  );
};
